import { gql } from "@apollo/client";

export const contractTypeQuery = gql`
  query campus($scenarioId: ID!, $filter: InstructorContractTypeFilterInput) {
    data(scenarioId: $scenarioId) {
      instructorContractTypes(filter: $filter) {
        items {
          id
          code
          name
        }
      }
    }
  }
`;
